// extracted by mini-css-extract-plugin
module.exports = {"cameraDetail":"CameraDetail_cameraDetail__lCFQ_"};